import PropTypes from "prop-types";

export const gridViewPropType = PropTypes.shape({
  isBuyNow: PropTypes.bool,
  isClearance: PropTypes.bool,
  isDepot: PropTypes.bool,
  isKids: PropTypes.bool,
  isHomeGood: PropTypes.bool,
  isRentable: PropTypes.bool,
  isRtrUpdate: PropTypes.bool,
  isUnlimited: PropTypes.bool,
});
